<template>
    <div class="gz-data__row">
        <div class="gz-data__row__container" :class="{'gz-data__row__container_title': title}" @click.stop="$emit('click')">
            <slot name="cols"></slot>
        </div>
        
        <div>
            <slot name="loader"></slot>
        </div>
        <!-- Открывающаяся панель с информацией -->
        <slot name="info-block"></slot>
    </div>
</template>

<script>

import accordion from '@/mixins/ui/accordion'

export default {
    name: 'BaseTableDataRow',

    props: {
        title: {
            type: Boolean,
            default: false
        }
    },
    mixins: [accordion],
    data() {
        return {
            open: false
        }
    },
    computed: {
        rowOpen() {
            return this.open
        }
    }
}
</script>